import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import SendSale from './modules/SendSaleMail';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

export const searchable: Record<string, any> = {
  _id: { ref: '_id', column: '_id', label: 'ID', show: false },
  project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
  event_id: { ref: 'event_id', column: 'event_id', label: 'Evento', show: false },
  name: { ref: 'name', column: 'name', label: 'Nome' },
  email: { ref: 'email', column: 'email', label: 'Email' },
  company: {
    ref: 'company',
    column: 'company',
    label: 'Empresa',
  },
  cpf_familiar: {
    ref: 'cpf_familiar',
    column: 'cpf_familiar',
    label: 'Categoria', show: false
  },
  category_id: {
    ref: 'category_id',
    column: 'category_id',
    label: 'Área',
  },
  position: {
    ref: 'position',
    column: 'position',
    label: 'Profissão',
  },
  updated_information: {
    ref: 'updated_information',
    column: 'updated_information',
    label: 'Atualizado?',
    show: false
  },

  createdAt: {
    ref: 'created_at',
    column: 'createdAt',
    label: 'Data de Criação',
    mask: 'date',
  },
};


const Dashboard: React.FC = () => {
  const endpoint = '/students';
  const title = 'Participantes';
  const { projectHash, eventHash } = useParams<IParams>();

  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    event_id: { ref: 'event_id', column: 'event_id', label: 'Evento', show: false },
    name: { ref: 'name', column: 'name', label: 'Nome' },
    email: { ref: 'email', column: 'email', label: 'Email' },
    company: {
      ref: 'company',
      column: 'company',
      label: 'Empresa',
    },
    cpf_familiar: {
      ref: 'cpf_familiar',
      column: 'cpf_familiar',
      label: 'Categoria', show: false
    },
    category_id: {
      ref: 'category_id',
      column: 'category_id',
      label: 'Área',
    },
    position: {
      ref: 'position',
      column: 'position',
      label: 'Profissão',
    },
    updated_information: {
      ref: 'updated_information',
      column: 'updated_information',
      label: 'Atualizado?',
      show: false
    },

    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    name: { model: 'input', type: 'text', name: 'name', label: 'Nome' },

    email: { model: 'input', type: 'text', name: 'email', label: 'Email' },
    category_id: {
      model: 'selectSimple',
      name: 'category_id',
      label: 'Categoria',

      options: [

        { label: 'Médicos, Dirigentes e Colaboradores da Unimed', value: 'Médicos, Dirigentes e Colaboradores da Unimed', text: 'Médicos, Dirigentes e Colaboradores da Unimed' },
        { label: 'Público Geral', value: 'Público Geral', text: 'Público Geral' },

      ]
    },
    company: {
      model: 'selectSimple',
      name: 'company',
      label: 'Empresa',

      options:
        [
          { value: "UNIMED ALEGRETE/RS", label: "UNIMED ALEGRETE/RS", text: "UNIMED ALEGRETE/RS" },
          { value: "UNIMED ALTO DA SERRA", label: "UNIMED ALTO DA SERRA", text: "UNIMED ALTO DA SERRA" },
          { value: "UNIMED ALTO JACUÍ/RS", label: "UNIMED ALTO JACUÍ/RS", text: "UNIMED ALTO JACUÍ/RS" },
          { value: "UNIMED ALTO URUGUAI/RS", label: "UNIMED ALTO URUGUAI/RS", text: "UNIMED ALTO URUGUAI/RS" },
          { value: "UNIMED CENTRO/RS", label: "UNIMED CENTRO/RS", text: "UNIMED CENTRO/RS" },
          { value: "UNIMED ENCOSTA DA SERRA/RS", label: "UNIMED ENCOSTA DA SERRA/RS", text: "UNIMED ENCOSTA DA SERRA/RS" },
          { value: "UNIMED ERECHIM/RS", label: "UNIMED ERECHIM/RS", text: "UNIMED ERECHIM/RS" },
          { value: "UNIMED FEDERAÇÃO/RS", label: "UNIMED FEDERAÇÃO/RS", text: "UNIMED FEDERAÇÃO/RS" },

          { value: "UNIMED FRONTEIRA NOROESTE/RS", label: "UNIMED FRONTEIRA NOROESTE/RS", text: "UNIMED FRONTEIRA NOROESTE/RS" },
          { value: "UNIMED ITAQUI/RS", label: "UNIMED ITAQUI/RS", text: "UNIMED ITAQUI/RS" },
          { value: "UNIMED LITORAL SUL/RS", label: "UNIMED LITORAL SUL/RS", text: "UNIMED LITORAL SUL/RS" },
          { value: "UNIMED MISSÕES/RS", label: "UNIMED MISSÕES/RS", text: "UNIMED MISSÕES/RS" },
          { value: "UNIMED NORDESTE - RS", label: "UNIMED NORDESTE - RS", text: "UNIMED NORDESTE - RS" },
          { value: "UNIMED NOROESTE/RS", label: "UNIMED NOROESTE/RS", text: "UNIMED NOROESTE/RS" },
          { value: "UNIMED PELOTAS/RS", label: "UNIMED PELOTAS/RS", text: "UNIMED PELOTAS/RS" },
          { value: "UNIMED PLANALTO CENTRAL/RS", label: "UNIMED PLANALTO CENTRAL/RS", text: "UNIMED PLANALTO CENTRAL/RS" },
          { value: "UNIMED PLANALTO MÉDIO/RS", label: "UNIMED PLANALTO MÉDIO/RS", text: "UNIMED PLANALTO MÉDIO/RS" },
          { value: "UNIMED PORTO ALEGRE", label: "UNIMED PORTO ALEGRE", text: "UNIMED PORTO ALEGRE" },
          { value: "UNIMED REGIÃO DA CAMPANHA/RS", label: "UNIMED REGIÃO DA CAMPANHA/RS", text: "UNIMED REGIÃO DA CAMPANHA/RS" },
          { value: "UNIMED REGIÃO DA FRONTEIRA/RS", label: "UNIMED REGIÃO DA FRONTEIRA/RS", text: "UNIMED REGIÃO DA FRONTEIRA/RS" },
          { value: "UNIMED REGIÃO DA PRODUÇÃO/RS", label: "UNIMED REGIÃO DA PRODUÇÃO/RS", text: "UNIMED REGIÃO DA PRODUÇÃO/RS" },
          { value: "UNIMED SANTA MARIA/RS", label: "UNIMED SANTA MARIA/RS", text: "UNIMED SANTA MARIA/RS" },
          { value: "UNIMED URUGUAIANA/RS", label: "UNIMED URUGUAIANA/RS", text: "UNIMED URUGUAIANA/RS" },
          { value: "UNIMED VALE DAS ANTAS, RS", label: "UNIMED VALE DAS ANTAS, RS", text: "UNIMED VALE DAS ANTAS, RS" },
          { value: "UNIMED VALE DO CAÍ/RS", label: "UNIMED VALE DO CAÍ/RS", text: "UNIMED VALE DO CAÍ/RS" },
          { value: "UNIMED VALE DO SINOS/RS", label: "UNIMED VALE DO SINOS/RS", text: "UNIMED VALE DO SINOS/RS" },
          { value: "UNIMED VALES DO TAQUARI E RIO PARDO", label: "UNIMED VALES DO TAQUARI E RIO PARDO", text: "UNIMED VALES DO TAQUARI E RIO PARDO" },
          { value: "UNIMED CENTRAL DE SERVIÇOS", label: "UNIMED CENTRAL DE SERVIÇOS", text: "UNIMED CENTRAL DE SERVIÇOS" },
          { value: "UNICOOPMED", label: "UNICOOPMED", text: "UNICOOPMED" },
          { value: "UNIAIR TRANSPORTE AEROMÉDICO", label: "UNIAIR TRANSPORTE AEROMÉDICO", text: "UNIAIR TRANSPORTE AEROMÉDICO" },
          { value: "INSTITUTO UNIMED/RS", label: "INSTITUTO UNIMED/RS", text: "INSTITUTO UNIMED/RS" },


        ]
    },
    education_id: {
      model: 'selectSimple',
      name: 'education_id',
      label: 'Escolaridade',
      options: [
        { value: "ANALFABETO", label: "ANALFABETO", text: "ANALFABETO" },
        { value: "PRIMÁRIO INCOMPLETO (ATÉ 4º)", label: "PRIMÁRIO INCOMPLETO (ATÉ 4º)", text: "PRIMÁRIO INCOMPLETO (ATÉ 4º)" },
        { value: "PRIMÁRIO COMPLETO", label: "PRIMÁRIO COMPLETO", text: "PRIMÁRIO COMPLETO" },
        { value: "ENSINO FUNDAMENTAL INCOMPLETO", label: "ENSINO FUNDAMENTAL INCOMPLETO", text: "ENSINO FUNDAMENTAL INCOMPLETO" },
        { value: "ENSINO FUNDAMENTAL COMPLETO", label: "ENSINO FUNDAMENTAL COMPLETO", text: "ENSINO FUNDAMENTAL COMPLETO" },
        { value: "ENSINO MÉDIO INCOMPLETO", label: "ENSINO MÉDIO INCOMPLETO", text: "ENSINO MÉDIO INCOMPLETO" },
        { value: "ENSINO MÉDIO COMPLETO", label: "ENSINO MÉDIO COMPLETO", text: "ENSINO MÉDIO COMPLETO" },
        { value: "ENSINO SUPERIO INCOMPLETO", label: "ENSINO SUPERIO INCOMPLETO", text: "ENSINO SUPERIO INCOMPLETO" },
        { value: "ENSINO SUPERIOR COMPLETO", label: "ENSINO SUPERIOR COMPLETO", text: "ENSINO SUPERIOR COMPLETO" },
        { value: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO", label: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO", text: "PÓS GRADUAÇÃO - ESPECIALIZAÇÃO" },
        { value: "MESTRADO", label: "MESTRADO", text: "MESTRADO" },
        { value: "DOUTORADO", label: "DOUTORADO", text: "DOUTORADO" }

      ]
    },
    birth_date: { model: 'datePicker', type: 'text', name: 'birth_date', label: 'Data de nascimento' },
    document_number: { model: 'input', type: 'text', name: 'document_number', label: 'CPF' },
    cpf_familiar: { model: 'input', type: 'text', name: 'cpf_familiar', label: 'RG' },
    extra_5: { model: 'input', type: 'text', name: 'extra_5', label: 'Campo emissor do RG' },


    password_hash: {
      model: 'input',
      type: 'password',
      name: 'password_hash',
      label: 'Senha',
    },
    profile: {
      model: 'selectSimple',
      name: 'profile',
      label: 'Nível',
      defaultValue: '2',
      options: [

        { label: 'Administrador', value: 1 },
        { label: 'Participante', value: 2 },
        { label: 'Mediador / Palestrante', value: 3 },
        { label: 'Organização', value: 4 },
        { label: 'Expositor', value: 5 },
        { label: 'Moderador de Chat', value: 6 },

        { label: 'Leitor de porta', value: 30 },
        { label: 'Leitor', value: 8 },
        { label: 'Gestor de conta', value: 9 },

      ],
    },

  };

  const formValidation: Record<string, ValidationSchema> = {

  };


  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchema,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        SendSale({
          lineData,

        }),

    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Dashboard;
